import { render, staticRenderFns } from "./seen.vue?vue&type=template&id=74ff77e3&scoped=true&"
import script from "./seen.vue?vue&type=script&lang=js&"
export * from "./seen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ff77e3",
  null
  
)

export default component.exports